// extracted by mini-css-extract-plugin
module.exports = {"notification":"EmailConfirmationBar_notification__1sYUp"};